import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ChatSidebarState {
  chatListRefreshKey: number;
  authRefreshRequestId: number;
  pendingPrompt: string | null;
}

const initialState: ChatSidebarState = {
  chatListRefreshKey: 0,
  authRefreshRequestId: 0,
  pendingPrompt: null,
};

const chatSidebarSlice = createSlice({
  name: 'chatSidebar',
  initialState,
  reducers: {
    bumpChatListRefresh(state) {
      state.chatListRefreshKey += 1;
    },
    requestAuthRefresh(state) {
      state.authRefreshRequestId += 1;
    },
    setPendingPrompt(state, action: PayloadAction<string | null>) {
      state.pendingPrompt = action.payload;
    },
  },
});

export const { bumpChatListRefresh, requestAuthRefresh, setPendingPrompt } = chatSidebarSlice.actions;

export const selectChatSidebar = (state: { chatSidebar: ChatSidebarState }) => state.chatSidebar;

export default chatSidebarSlice.reducer;